import React from "react";
import { Link } from "react-router-dom";
import "../../Styles/Feestructure.css";



export default function Feestructure() {
    return (
        <div className="feestruc-container my-4">
            <div className="special-header panel-white-all mb-4">
                <h4 className="page-title mt-1">Fee Structure</h4>
            </div>
            <div className="row feestruct-cardbg">
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-1 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2023-2024</b></h5>
                            <p className="card-text">Start Date:Wed Jan 1 2025
                                <p className="card-text">End Date:Wed Dec 31 2025</p>
                            </p>
                             <Link to="/firstcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-2 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>Tests</b></h5>
                            <p className="card-text">Start Date:Thu May 22 2025
                                <p className="card-text">End Date:Thu Oct 30 2025</p>
                            </p>
                             <Link to="/secondcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-3  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2020-2021</b></h5>
                            <p className="card-text">Start Date:Wed Jan 1 2020
                            <p className="card-text">End Date:Thu Dec 31 2020</p></p>
                            <Link to="/thirdcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12 mb-4">
                    <div className="card feestruc-cardss-4  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2019-2020</b></h5>
                            <p className="card-text">Start Date:Mon Jun 3 2019
                            <p className="card-text">End Date:Fri May 1 2020</p></p>
                             <Link to="/fourthcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>               </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12 mb-4">
                    <div className="card feestruc-cardss-5  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2019-2020</b></h5>
                            <p className="card-text"> Start Date:Wed Jan 1 2020
                            <p className="card-text">End Date:Thu Dec 31 2020</p></p>
                             <Link to="fifthcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>                    </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-6  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2021-2022</b></h5>
                           
                            <p className="card-text ">Start Date:Wed Dec 1 2021
                            <p className="card-text">End Date:Sat Dec 31 2022</p></p>
                            <Link to="sixthcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-7 text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>NewYear</b></h5>
                            
                            <p className="card-text">Start Date:Sat Jan 1 2020
                            <p className="card-text">End Date:Sat Dec 31 2022</p></p>
                             <Link to="newyear" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-8  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2022</b></h5>
               
                            <p className="card-text text-center">Start Date:Mon Jun 1 2020
                            <p className="card-text">End Date:Wed Sep 31 2021</p></p>
                             <Link to="eighthcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  mb-4">
                    <div className="card feestruc-cardss-9  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>NewYear2022</b></h5>
                           
                            <p className="card-text">Start Date:Sat Jan 1 2022
                            <p className="card-text">End Date:Sat Dec 31 2022</p></p>
                             <Link to="newyear" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-lg-4 col-sm-12  ">
                    <div className="card feestruc-cardss-10  text-center">
                        <div className="card-body">
                            <h5 className="card-title"><b>2022-2023</b></h5>
                            <p className="card-text">Start Date:Wed Jun 1 2022
                               <p className="card-text"> End Date: Wed May 31 2023</p>
                            </p>
                             <Link to="tenthcard" className="btn"><i className="bi bi-arrow-up-right-square-fill"></i>View</Link></div>
                    </div>
                </div>
            </div>
        </div>
    );
}